import { render } from "./transfer.vue?vue&type=template&id=076ca942&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"

import "./transfer.vue?vue&type=style&index=0&id=076ca942&scoped=true&lang=css"
import "./transfer.vue?vue&type=style&index=1&id=076ca942&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076ca942"]])

export default __exports__